import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'netplatform-prodkeymodal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        prodKeywordList: [],
        manufactureKeywordList: []
      })
    },
    supplierId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const visible = computed({
      get: () => props.modelValue,
      set: val => emits('update:modelValue', val)
    });
    watch(() => props.modelValue, v => {
      if (v) {
        keyList.value = props.data.prodKeywordList.map(v => ({
          value: v
        }));
        manuKeyList.value = props.data.manufactureKeywordList.map(v => ({
          value: v
        }));
      }
    });
    const keyList = ref([{
      value: ''
    }]);
    const manuKeyList = ref([{
      value: ''
    }]);

    function confirm() {
      let keyListSuccess = keyList.value.every(v => v.value != '');

      if (!keyListSuccess) {
        ElMessage.error('商品名称关键词填写不完整');
        return;
      }

      let manuKeyListSuccess = manuKeyList.value.every(v => v.value != '');

      if (!manuKeyListSuccess) {
        ElMessage.error('厂家名称关键词填写不完整');
        return;
      }

      let body = {
        supplierId: props.supplierId,
        prodNo: props.data.prodNo,
        prodKeywordList: keyList.value.map(v => v.value),
        manufactureKeywordList: manuKeyList.value.map(v => v.value)
      };
      Axios.post('/admin/supplier/editSpiderkeyword', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          emits('success');
          visible.value = false;
          return;
        }

        ElMessage.error(msg);
      });
    }

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_CirclePlus = _resolveComponent("CirclePlus");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_DeleteFilled = _resolveComponent("DeleteFilled");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "关键词维护",
        width: "700px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "form",
          class: "netplatform-prodkeymodal"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商品名称"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(__props.data.prodName), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品名称关键词"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyList.value, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                class: "wrapper",
                key: i
              }, [_createVNode(_component_el_input, {
                modelValue: v.value,
                "onUpdate:modelValue": $event => v.value = $event,
                placeholder: "请输入商品名称"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_icon, {
                onClick: _cache[0] || (_cache[0] = $event => keyList.value = [...keyList.value, {
                  value: ''
                }])
              }, {
                default: _withCtx(() => [_createVNode(_component_CirclePlus)]),
                _: 1
              }), i > 0 ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                onClick: $event => keyList.value.splice(i, 1)
              }, {
                default: _withCtx(() => [_createVNode(_component_DeleteFilled)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)]);
            }), 128))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "厂家关键词"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manuKeyList.value, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                class: "wrapper",
                key: i
              }, [_createVNode(_component_el_input, {
                modelValue: v.value,
                "onUpdate:modelValue": $event => v.value = $event,
                placeholder: "请输入厂家名称"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_icon, {
                onClick: _cache[1] || (_cache[1] = $event => manuKeyList.value = [...manuKeyList.value, {
                  value: ''
                }])
              }, {
                default: _withCtx(() => [_createVNode(_component_CirclePlus)]),
                _: 1
              }), i > 0 ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                onClick: $event => manuKeyList.value.splice(i, 1)
              }, {
                default: _withCtx(() => [_createVNode(_component_DeleteFilled)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};